import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { SessionService } from '../other/session';

/**
 * Gates the committee create/edit flow to System Admins only. Mirrors the list
 * page's canCreate() so the role-gate is authoritative at the route level, not
 * just by hiding the Create button. (Committees/teams are managed from the
 * admin-only General Settings tab.)
 */
export const committeeManageGuard: CanActivateFn = () => {
  const session = inject(SessionService);
  const router = inject(Router);

  return session.isAdmin() ? true : router.createUrlTree(['/main/committees']);
};
